<template>
  <div id="app">
    <div class="introduction" v-if="!showDescription">
      <h1 style="text-align: center">The Simon Game </h1>
      <p class="description-p">
        Simon is an electronic game of memory skill, The device creates a series of lights and requires a user to repeat the sequence. If the user succeeds, the series becomes progressively longer and more complex. Once the user fails or the time limit runs out, the game is over
      </p>
      <button class="btn-start" @click="showDescription = true" >
        Start Game
      </button>
    </div>

  <div v-show="showDescription">

    <div class="container">
      <h1 id="level-title">Press A Key to Start The Game</h1>
      <div class="row up">

        <div type="button" id="green" class="btn green "></div>

        <div type="button" id="red" class="btn red "></div>
      </div>

      <div class="row">
        <div type="button" id="yellow" class="btn yellow"></div>
        <div type="button" id="blue" class="btn blue"></div>
      </div>
    </div>
    </div>
  </div>
<!--  </div>-->
</template>

<script>


export default {
  name: "TheSimonGame.component",
  el: "#app",
  data: function() {
    return {
      showDescription : false,
      level: 0,
      gamePattern: [],
      userClickedPattern: [],
      buttonColours: ["red", "blue", "green", "yellow"],
      started: false,
      randomNumber: null,
      userChosenColour: null,
      randomChosenColour: null
    }
  },
mounted() {

  $(document).keypress( (event) => {

    if (!this.started) {
      $("#level-title").text("Level " + this.level);
      this.nextSequnce();
      this.started = true;
    }
  });

  $(".btn").click( (event) => {
    this.userChosenColour = event.target.id;

    this.userClickedPattern.push(this.userChosenColour);
    this.checkAnswer(this.userClickedPattern.length - 1);
    this.animatePress(this.userChosenColour);
  });
},
  methods: {
    nextSequnce() {

  this.level++;
  $("#level-title").text("Level " + this.level);
  this.randomNumber = Math.floor(Math.random() * 4);

  this.randomChosenColour = this.buttonColours[this.randomNumber];
  this.gamePattern.push(this.randomChosenColour);

  $("." + this.randomChosenColour)
      .fadeIn(100)
      .fadeOut(100)
      .fadeIn(100);

},

    animatePress(currentColour) {
  $("." + currentColour).addClass("pressed");

  setTimeout(() => {
    $("." + currentColour).removeClass("pressed");
  }, 100);
},

    checkAnswer(currentLevel) {
  // check the recent answer same as game pattern
  if (this.userClickedPattern[currentLevel] === this.gamePattern[currentLevel]) {

  }
  //if user wrong
  else {

    setTimeout(function () {
      $("body").removeClass("game-over");
    }, 200);

    $("#level-title").text("Game over, press any key to restart");
    this.startOver();
  }
  // check if the user finish sequence correctly
  if (currentLevel + 1 === this.level) {
    this.userClickedPattern = [];
    setTimeout( ()=> {
      this.nextSequnce();
    }, 1000);
  }
},

    startOver() {
  this.gamePattern = [];
  this.level = 0;
  this.started = false;
  this.userClickedPattern = [];
},
  }
}

</script>

<style scoped lang="scss">
body {
  text-align: center;
  background-color: #011F3F;
}
.introduction{
 position: relative;
  top: 200px;
  left: 31%;
  width: 25%;
  content-visibility: auto;
  border: 3px solid black;
  padding: 10px;
}
.description-p{
  font-size: 1.7rem;
  text-align: center;
}

.btn-start{
 margin-left: 30%;
 margin-top: 2rem;

  background-color: grey;
  border: 0;
  border-radius: 200px;
  padding: 16px 24px;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 1.25px;
  font-size: 16px;

  min-width: 160px;
  outline: none;
  -webkit-transition: 0.25s;
  transition: 0.25s;
  opacity: 0.75;
  cursor: pointer;
}

#level-title {

  font-size: 2.5rem;
  text-align: center;
  margin-top: 7.5rem;
  color: black;
}

.container {
  display: block;

}

.row{
  margin-left: 34%;
}

.row:after{
  display: none;
}

.up{
  margin-top: 5rem;
}

.btn {
  margin: 25px;
  display: inline-block;
  height: 130px;
  width: 130px;
  border: 10px solid black;
  border-radius: 20%;
}

.game-over {
  background-color: red;
  opacity: 0.8;
}

.red {
  background-color: red;
}

.green {
  background-color: green;
}

.blue {
  background-color: blue;
}

.yellow {
  background-color: yellow;
}

.pressed {
  box-shadow: 0 0 20px white;
  background-color: grey;
}
</style>